import { routeForRoles } from "../../../security/roles";

const browserDefaultBaseURL =
  typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.hostname}`
    : "http://127.0.0.1";

export const DEFAULT_BASE_URL = browserDefaultBaseURL;

// Sem Comercial nem Tecnico: entram pela app móvel, e o servidor recusa-lhes
// o login na consola. Mapeá-los para "/home" dava-lhes o painel do operário.
const GROUP_ROUTE_MAP = {
  Operario: "/home",
  Director: "/admin/home",
  Contabilidade: "/cont/home",
  recargatest: "/test/home",
  IRS: "/irs/home",
};

export function getRouteByGroup(grupo, roles = []) {
  if (Array.isArray(roles) && roles.length) return routeForRoles(roles, grupo);
  return GROUP_ROUTE_MAP[grupo] || "/home";
}
